const useMouseEvents = (handler) => {
    return {
        onPointerOver: handler,
        onPointerDown: handler,
        onClick: handler,
        onPointerMove: handler,
        onPointerOut: handler,
    };
};

export default useMouseEvents